import styled from "styled-components"

const CTA = styled.button`
  background: #b6d882;
  text-transform: uppercase;
  font-size: 1rem;
  font-family: "Lato";
  font-weight: 600;
  padding: 0.7rem 1.5rem;
  border-radius: 3px;
  color: white;
  cursor: pointer;
  border: none;

  &:hover {
    text-decoration: underline;
    background: #96b566;
    a {
      text-decoration: underline;
    }
  }

  a {
    text-decoration: none;
    color: white;
  }
`

export default CTA
